import { configureStore } from "@reduxjs/toolkit";
import connectEvoltReducer from "../slice/Evolt/emailAddressSlice";
import connectInBodyReducer from "../slice/phoneNumberSlice";
import smsVerificationCodeInBodyReducer from "../slice/smsVerificationCodeSlice";

//store
const store = configureStore({
  reducer: {
    connectEvolt: connectEvoltReducer,
    connectInBody: connectInBodyReducer,
    smsVerificationCodeInBody: smsVerificationCodeInBodyReducer,
  },
});

export default store;
